"use client";
import React, { useContext, useEffect, useState } from "react";
import styles from "./FreeKundli.module.scss";
import { AstroUserData, UserAstroProfile } from "../Enum";
import FormCard from "../components/FormCard";
import { usePathname, useRouter } from "next/navigation";
import { formFields2 } from "../components/FormCard/formFields";
import LogoNavBarAstroProfiles from "../components/LogoNavBarAstroProfiles";
import { addAstroProfiles, fetchAstroProfiles } from "@/services/astro.service";
import { FormResponse } from "../helpers/CreatorForm.types";
import { getFormatDateFromPrediction2 } from "../helper";
import ExistingKundli from "../KundliMatch/ExistingKundli";
import useAppContext from "@/customhooks/useAppContext";
import { AppContext } from "@/context/AppContext";
import { sendChatInvite } from "@/services/chat.service";
import BackButton from "@/common/components/BackButton";

interface FreeKundliProps {
  type?: string;
  title?: string;
  submitBtnTxt?: string;
  onFormSubmit?: (data: AstroUserData) => void;
  formFieldsList?: {
    id: number;
    label: string;
    name: string;
    required: boolean;
  }[];
  showBackBtn?: boolean;
  receiverUserId?: string;
}

const FreeKundli = ({
  type,
  title = "Find the details below",
  submitBtnTxt = "Check Kundli",
  onFormSubmit,
  formFieldsList = formFields2,
  showBackBtn = false,
  receiverUserId,
}: FreeKundliProps) => {
  const token = useAppContext()?.auth.token ?? "";
  const { setChatIntakeData } = useAppContext() ?? "";
  const formCardRef = React.useRef<React.FC>(null);
  const [submit, setSubmit] = useState(false);
  const [profiles, setProfiles] = useState<UserAstroProfile[]>([]);
  const [activeProfile, setActiveProfile] = useState(-1);
  const [astroProfilePopup, setAstroProfilePopup] = useState("");
  const router = useRouter();

  const context = useContext(AppContext);
  const {
    paidDmSocket,
    chatData,
    setChatData,
    userData,
    auth,
    setPopups,
    setToastData,
  } = context ?? {};

  const onFetchProfiles = async () => {
    const res = await fetchAstroProfiles(token);
    if (res?.data) {
      setProfiles(res?.data ?? []);
    }
  };

  const handleSubmit = () => {
    setSubmit(true);
    setTimeout(() => setSubmit(false), 500);
  };

  const checkIfNewProfile = async (
    newProfileData: AstroUserData,
    initProfileData: FormResponse
  ) => {
    if (profiles?.length >= 4) return;
    if (
      newProfileData?.pob !== initProfileData?.place_of_birth ||
      newProfileData?.tob !== initProfileData?.time_of_birth ||
      newProfileData?.name !== initProfileData?.name ||
      getFormatDateFromPrediction2(newProfileData?.dob).toDateString() !==
        getFormatDateFromPrediction2(
          initProfileData?.DOB as string
        ).toDateString()
    ) {
      token && (await addAstroProfiles(newProfileData, token));
    }
  };

  const getFormData = (formName: string, data: AstroUserData | null) => {
    if (!data) {
      setSubmit(false);
      return;
    }

    data.tob = `${data?.tob}:00`;
    checkIfNewProfile(data, getInitialData())
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });

    if (type === "chat-intake-form" && receiverUserId) {
      setChatIntakeData && setChatIntakeData(data);

      setChatData &&
        setToastData &&
        sendChatInvite(
          paidDmSocket,
          receiverUserId,
          setChatData,
          setToastData,
          chatData?.currencyType
        );
      router.back();
      return;
    }

    if (onFormSubmit) {
      onFormSubmit({
        ...data,
        gender: mapGender?.[data?.gender]?.toLowerCase(),
      });
    } else {
      router.push(
        `/free-kundli/kundli?date=${data?.date}&lat=${data?.lat}&long=${
          data?.long
        }&tzone=${data?.tzone}&name=${data?.name}&gender=${mapGender?.[
          data?.gender
        ]?.toLowerCase()}`
      );
    }
  };

  const mapGender: { [key: string]: string } = {
    M: "Male",
    F: "Female",
  };

  const getInitialData = () => {
    if (activeProfile < 0) {
      return {};
    }
    const profile = profiles?.[activeProfile] ?? {};

    return {
      name: (profile?.firstName ?? "") + " " + (profile?.lastName ?? ""),
      DOB: profile?.dob ?? "1998-01-20",
      time_of_birth: profile?.tob?.slice(0, 5) ?? "",
      place_of_birth: profile?.pob ?? "",
      gender: mapGender?.[profile?.gender] ?? "",
    };
  };

  const onPopupClose = (newProfiles?: UserAstroProfile[]) => {
    profiles && setProfiles(newProfiles ?? []);
    setAstroProfilePopup("");
  };

  const handleProfileChange = (index: number) => {
    setActiveProfile(index);
  };

  useEffect(() => {
    void onFetchProfiles();
  }, [token]);

  return (
    <>
      {showBackBtn && <BackButton customClass={styles.back_btn} />}
      <div className={styles.freeKundliCont}>
        <p className={styles.heading}>{title}</p>
        <LogoNavBarAstroProfiles
          activeProfile={activeProfile}
          setActiveProfile={handleProfileChange}
          profiles={profiles}
        />
        <div className={styles.contentWrapper}>
          <form className={styles.centerWrapper}>
            <FormCard
              initialData={getInitialData()}
              submit={submit}
              onSubmit={getFormData}
              formFields={formFieldsList}
            />
          </form>
          <div className={styles.buttonWrapper}>
            <button onClick={handleSubmit}>{submitBtnTxt}</button>
          </div>
        </div>
      </div>
    </>
  );
};
export default FreeKundli;
